import React from 'react'

import './ErrorPage.css'
const ErrorPage = () => {
    return (
		<div className="error-container">
			<h1 className="error-header">404</h1>
		<img className="error-image" src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"/>
			</div>
		
    )
}

export default ErrorPage
